import * as msc from "mascot-vis";
import { getPositionInScene } from "../Util";
import store from "../store";
import { directSelect, directSelectPreview, rectSelect, toggleAxisHandle } from "../canvasSlice";

var downX, downY, clickHeld = false;

export const mouseDown = (e, scene) => {
    const p = getPositionInScene(e.clientX, e.clientY);
    const item = msc.inMarkHitTest(scene, p[0], p[1], 4);
    if (!item) {
        downX = e.clientX;
        downY = e.clientY;
        clickHeld = true;
    }
}

export const mouseUp = (e, scene, renderer) => {
    if (clickHeld) {
        let pos = getPositionInScene(Math.min(downX, e.clientX), Math.min(downY, e.clientY));
        let left = pos[0], top = pos[1], wd = Math.abs(e.clientX - downX), ht = Math.abs(e.clientY - downY);
        store.dispatch(rectSelect({left: left, top: top, width: 0, height: 0}));
        let r = {left: left, top: top, width: wd, height: ht, right: left + wd, bottom: top + ht};
        let itm = msc.inMarkRectHitTest(scene, r, 2);
        store.dispatch(directSelect(itm ? itm.id : null));
        clickHeld = false;
    } else {
        const p = getPositionInScene(e.clientX, e.clientY);
        const item = msc.inMarkHitTest(scene, p[0], p[1], 4);
        store.dispatch(directSelect(item ? item.id : null));
    }
}

export const mouseMove = (e, scene) => {
    if (!clickHeld) {
        const p = getPositionInScene(e.clientX, e.clientY);
        const itm = msc.hitTest(scene, p[0], p[1]);
        if (itm && itm.type === "axis" && itm.encoding) {
            store.dispatch(toggleAxisHandle({axis: itm.id, visible: true}));
        } else {
            store.dispatch(toggleAxisHandle({visible: false}));
                // const item = msc.inMarkHitTest(scene, p[0], p[1], 4);
                // store.dispatch(directSelectPreview(item ? item.id : null));
        }

        const item = msc.inMarkHitTest(scene, p[0], p[1], 4);
        store.dispatch(directSelectPreview(item ? item.id : null));

        // const leafItem = msc.hitTestAll(scene, p[0], p[1]);
        // if (leafItem && leafItem.type === "path" && !store.getState().canvas.directSelected) {
        //     d3.select("#pathOutline").style("visibility", "visible");
        //     d3.select("#pathSegments").attr("d", leafItem.getSVGPathData());
        //     d3.select("#pathVertices").attr("d", getSVGPathData(leafItem.vertices, 2));
        // } else {
        //     d3.select("#pathOutline").style("visibility", "hidden");
        // }
    } else {
        let pos = getPositionInScene(Math.min(downX, e.clientX), Math.min(downY, e.clientY));
        let left = pos[0], top = pos[1], wd = Math.abs(e.clientX - downX), ht = Math.abs(e.clientY - downY);
        store.dispatch(rectSelect({left: left, top: top, width: wd, height: ht}));
    }
}